import useJwt from '@/auth/jwt/useJwt'
import jwt from 'jsonwebtoken'
import store from '@/store'
/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */

export const getAccessToken = () => store.getters['user/accessToken']

export const getAuthToken = () => {
  let token = {}
  const accessToken = getAccessToken()
  if (accessToken) {
    token = {
      key: 'Authorization',
      value: `Bearer ${accessToken}`
    }
  }
  return token
}
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  return localStorage.getItem('userData') && localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName)
}

export const isValidToken = () => {
  try {
    const accessToken = getAccessToken()
    if (!accessToken) return false

    // Frontend should not verify JWT signature with a secret.
    // We only validate token expiry (exp) so navigation isn't blocked by secret mismatch.
    const decoded = jwt.decode(accessToken)
    if (!decoded || typeof decoded.exp === 'undefined') return false

    const expMs = Number(decoded.exp) * 1000
    if (Number.isNaN(expMs)) return false

    return expMs > Date.now()
  } catch (error) {
    return false
  }
}

export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = (userRole) => {
  if (userRole === 'super-admin') return '/'
  return { name: 'login' }
}
